1<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "QuantifyCountryDescription",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'quantifyCountryDescription:add',
        update: 'quantifyCountryDescription:update',
        delete: 'quantifyCountryDescription:delete',
        deleteBatch: 'quantifyCountryDescription:deleteBatch'
      },
      url: {
        get: '/quantifyCountryDescription/listByCondition',
        add: '/quantifyCountryDescription/add',
        update: '/quantifyCountryDescription/update',
        delete: '/quantifyCountryDescription/delete/',
        delete_batch: '/quantifyCountryDescription/deleteBatch',
        status: '/quantifyTimeZoneConfig/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },{
        field: 'countryId',
        label: '国家ID',
        selectUrl: '/country/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      },{
        field: 'description',
        label: '量化国家时区描述',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '量化时区配置',
        updateTitle: '量化时区配置',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'countryId',
          label: '国家ID',
          type: 'select',
          selectUrl: '/country/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择国家ID', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        },  {
          field: 'description',
          label: '量化国家时区描述',
          type: 'input',
          placeholder: '量化国家时区描述',
          rules: [{message: '请输入量化国家时区描述', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, ],
      }
    }
  }
}
</script>

<style scoped>

</style>
